export const USER_FEATURES = {
    CHAT : 'chat',
    TRANSCRIPTION:'transcription',
    DESKTOP_APP:'desktopapp',
    CLOUD_RECORDING:'cloudrecording',
}

export const RCRD_CUSTOM_BIG_MEET_CONFIG_CODE = "RCRD_CUSTOM_BIG_MEET";
